import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-cards';
import CuratedContentCarouselCard from 'Components/UI/Carousel/CuratedContentCarouselCard';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import { EffectCards } from './FacetEffectCards';

const styles = (theme) => ({
  swiperContainer: {
    overflow: 'hidden',
    padding: theme.spacing(1, 0),
  },
  swiper: {
    width: 275, // Must match size of cards or the Cards Effect is ruined
  },
  slide: {
    boxShadow: theme.shadows[4],
    borderRadius: theme.radius.md,
    overflow: 'hidden',
  },
  nav: {
    margin: theme.spacing(0, 1),
  },
});

/*
Swiper Effect Cards "cardsEffect" prop docs
https://swiperjs.com/types/interfaces/types_modules_effect_cards.cardseffectoptions
 */

const Carousel = ({
  className,
  classes,
  slides,
}) => {
  const [activeIndex, setActiveIndex] = React.useState(0);

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  // We need a component inside <Swiper /> to be able to use the useSwiper() hook. The activeIndex prop allows us to
  //  navigate to a specific slide from outside the <Swiper /> component
  const IndexChangeListener = (props) => {
    const { activeIndex: i } = props;
    const swiper = useSwiper();

    React.useEffect(() => {
      swiper.slideTo(i, 500, true);
    }, [i]);

    return null;
  };

  return (
    <div className={classes.swiperContainer}>
      <Swiper
        className={classNames(classes.swiper, className)}
        effect={'cards'}
        modules={[EffectCards]}
        grabCursor
        cardsEffect={{
          rotate: false,
          slideShadows: false,
        }}
        onSlideChange={handleSlideChange}
      >
        <IndexChangeListener activeIndex={activeIndex} />
        {slides.map(slide => (
          <SwiperSlide className={classes.slide} key={`slide-${slide.id()}`}>
            <CuratedContentCarouselCard resource={slide} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

Carousel.defaultProps = {
  className: '',
};

Carousel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  slides: PropTypes.array.isRequired,
};

export default withStyles(styles)(Carousel);
